import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import { reducer as form } from 'redux-form';

import { reducer as Login } from 'containers/Login';
import { reducer as ForgotCredentialsModal } from 'containers/ForgotCredentialsModal';

export default combineReducers({
  routing: routerReducer,
  form,
  Login,
  ForgotCredentialsModal,
});
